import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/rit-inconvenientes";
const url = (path = "") => `${baseUrl}${endpoint}${path}`;

/** Listado paginado con filtros: { modulo, estado, municipio, documento, page, pageSize } */
export const listarInconvenientesRit = async (filtros = {}) => {
  const response = await axios.get(url("/"), { params: filtros });
  return response.data;
};

/** Conteo { PENDIENTE, CORREGIDO }, opcionalmente por módulo. */
export const obtenerConteoInconvenientesRit = async (modulo) => {
  const response = await axios.get(url("/conteo"), { params: modulo ? { modulo } : {} });
  return response.data;
};

export const cambiarEstadoInconvenienteRit = async (id, estado) => {
  const response = await axios.patch(url(`/${id}/estado`), { estado });
  return response.data;
};
